export const REDUCER_KEY = 'attachments';
